import { render } from "./PayoutDetails.vue?vue&type=template&id=10c5aa3c"
import script from "./PayoutDetails.vue?vue&type=script&lang=js"
export * from "./PayoutDetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\justi\\Code\\vuekillmailtool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__